import { useMergeGoalLinkChanges as _useMergeGoalLinkChanges } from '@griply/hooks';
import { mergeGoalLinkChanges } from '@griply/services';
import { useLocalizedLifeAreas } from 'features/life-areas';
import { useEntityLinks } from 'shared/hooks/use-entity-links';
import { useUpdateRelationshipsReferences } from 'shared/hooks/use-update-relationships-references';

import { useGoals } from './use-goals';

export type { GoalLinkChanges } from '@griply/hooks';

export const useMergeGoalLinkChanges = () => {
  const updateRelationships = useUpdateRelationshipsReferences();
  const links = useEntityLinks();
  const goals = useGoals();
  const lifeAreas = useLocalizedLifeAreas();

  return _useMergeGoalLinkChanges({
    goals,
    links,
    lifeAreas,
    mergeGoalLinkChanges,
    updateRelationships,
  });
};
